import { useLocale } from "../../hooks/use-locale"
import { CompanyStats, ValueFormat } from "./types"
import { useCompanyStatsQuery } from "./use-company-stats-query"
import { formatValue } from "./utils"

export const useCompanyStats = () => {
  const queryResults = useCompanyStatsQuery()
  const locale = useLocale()
  return queryResults.datoCms.allCompanyStatisticValues.reduce(
    (acc, { title, baseValue, unit }) => {
      const value = baseValue * unit
      acc[title] = (format?: ValueFormat) => formatValue(value, format, locale)
      return acc
    },
    {} as CompanyStats,
  )
}
